import SEOTestPage from '../../components/SEOTestPage';
import { SEO_TESTS } from '../../data/seoTestsConfig';
export default function DepresifBelirtilerTestiPage() {
  return <SEOTestPage testConfig={SEO_TESTS['depresif-belirtiler-testi']} />;
}
